define('core/views/media/UploadsRichSubView',[
    'underscore',
    'backbone',

    'core/models/Media',
    'core/UniqueModel',
    'core/utils',

    'core/templates/postMediaUploadRich',
], function (
    _,
    Backbone,

    Media,
    UniqueModel,
    utils,

    postMediaUploadRichTemplate
) {
    'use strict';

    // View which renders a collection of Media models as thumbnails.
    // Supports synchronizing the model collection with the urls
    // present in text input; see updateFromText
    var UploadsRichSubView = Backbone.View.extend({
        initialize: function () {
            // Track if any thumbnails were rendered.
            // This is used by parent views, via the hasVisible method.
            this._hasVisible = false;

            this.collection = new Backbone.Collection([], {
                model: Media,

                // Keep the collection sorted by the
                // order of the urls in the text
                // (by index of bleachFindUrls result)
                comparator: 'index',
            });

            // Render on every event which could update visible media previews
            this.listenTo(this.collection, 'add remove reset sort ' +
                'change:thumbnailUrl change:mediaType change:editsFinished', this.render);

            // Workaround: Backbone will not sort the collection when
            // the model changes
            // Ref: https://github.com/jashkenas/backbone/issues/2237
            this.listenTo(this.collection, 'change:index',
                _.bind(this.collection.sort, this.collection));
        },

        render: function () {
            this.$el.empty();
            this._hasVisible = false;
            this.collection.each(function (model) {
                // Don't render element if there isn't a thumbnail
                if (!model.get('thumbnailUrl'))
                    return;

                // Don't render element if it's a webpage type
                if (_.contains(Media.WEBPAGE_TYPES, model.get('mediaType')))
                    return;

                // Don't render element if the user is likely to
                // be editing the url
                if (!model.get('editsFinished'))
                    return;

                // Add to DOM
                this.$el.append(postMediaUploadRichTemplate({
                    media: model.toJSON(),
                }));

                // Keep track of there being at least one visible
                // Media model for this view
                this._hasVisible = true;
            }, this);

            return this;
        },

        hasVisible: function () {
            return this._hasVisible;
        },

        addMedia: function (mediaAttrs, options) {
            var media = UniqueModel.get(Media, mediaAttrs.url);
            if (media) {
                // Update existing Media model
                media.set(mediaAttrs);
            } else {
                // Abort if it's possible the user is editing the url
                if (!mediaAttrs.editsFinished)
                    return;

                // Create and fetch Media model
                media = new UniqueModel(Media, mediaAttrs);
                media.fetch(options);
            }

            this.collection.add(media);

            return media;
        },

        updateFromText: function (text, cursorPosition, options) {
            if (!text)
                return void this.collection.reset();

            // Find urls in text
            var matches = utils.bleachFindUrls(text);

            // Remove duplicates, to avoid trigerring sort events
            matches = _.uniq(matches, false, function (match) {
                return match.url;
            });

            // Keep track of which urls we updated, so we can remove the others later
            var urlsUpdated = {};

            // Add models to collection
            _.each(matches, function (match) {
                urlsUpdated[match.url] = true;

                var mediaAttrs = _.pick(match, 'index', 'url');

                // Check if cursor is within url
                var beingEdited = (match.index < cursorPosition &&
                                   cursorPosition <= match.endIndex) ||
                    text[match.endIndex] === '.';

                // Permit the model to be rendered if the cursor is
                // at any time not in the url, or there is a paste
                // event.
                if (!beingEdited || options.isPasteEvent)
                    mediaAttrs.editsFinished = true;

                this.addMedia(mediaAttrs, options);
            }, this);

            // Remove urls which are no longer present.
            // Algorithm is not efficient, but is capped by the number of urls the user enters.
            var currentUrls = this.collection.pluck('url');
            urlsUpdated = _.keys(urlsUpdated);
            var removeUrls = _.difference(currentUrls, urlsUpdated);
            this.collection.remove(this.collection.filter(function (model) {
                return _.contains(removeUrls, model.get('url'));
            }));
        },
    });

    return UploadsRichSubView;
});

